import { render, staticRenderFns } from "./BoxInnerWidth.vue?vue&type=template&id=23e4afb6&"
import script from "./BoxInnerWidth.vue?vue&type=script&lang=ts&"
export * from "./BoxInnerWidth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports